import React, { useState } from "react";
import styles from "../faq.module.scss";
import SearchIcon from "@Icons/SearchIcon";
import CrossIcon from "@Icons/CrossIcon";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";

interface SearchInputProps {
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearch: () => void;
}

const SearchInput: React.FC<SearchInputProps> = ({ searchTerm, onSearchChange, onClearSearch }) => {
  const [isFocused, setIsFocused] = useState(false);
  const { t } = useTranslationHook();

  return (
    <div className={styles.searchFaq}>
      <div className={formatClassNames(styles.inner, isFocused && styles.focused)}>
        <div
          className={styles.searchInput}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        >
          <SearchIcon fill="#000" />
          <input
            data-testid="FAQ-search-bar"
            className={styles.input}
            value={searchTerm}
            onChange={onSearchChange}
            placeholder={t("propertypage.sectionregioninfo.enteryourquery")}
          />
          {(searchTerm || isFocused) && (
            <div
              data-testid="FAQ-search-bar-clear"
              className={styles.clearButton}
              onClick={onClearSearch}
              role="none"
            >
              <CrossIcon size={12} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default wrapperHOC(SearchInput, {
  componentName: "FAQs-SearchInput",
  showForChina: true,
  showForWhiteLable: true,
});
